module.exports = __webpack_public_path__ + "static/Letter-voter.a1e06a0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Letter-voter.png
// module id = 501
// module chunks = 265584890008614